import { MenuItem, SubMenuItem } from '@eika/menu';

import { ScMenuItem, ScNativeMenuItem, ScSubMenuItem, ScLogo, MalbankLink, HeaderApp } from './default-config';

type Link = import('@eika/menu').Link;

export interface LogoProps {
    src: string;
    altText: string;
    homePath: string;
}

export interface HeaderAppProps {
    srcRoot: string;
    namespace: string;
    config: Record<string, string>;
}

const subMenuConfigMapper = (subMenuItems: ScSubMenuItem[]): SubMenuItem[] | undefined => {
    if (!subMenuItems.length) {
        return undefined;
    }

    return subMenuItems.map((subMenuItem) => ({
        id: subMenuItem.Id,
        name: subMenuItem.Name,
        link: {
            url: subMenuItem.Link.Url,
            target: subMenuItem.Link.Target,
        },
        isExternalLink: subMenuItem.IsExternalLink,
        isActive: subMenuItem.IsActive,
    }));
};

const menuConfigMapper = (menuItems: ScMenuItem[]): MenuItem[] | undefined => {
    if (menuItems == null || !menuItems.length) {
        return undefined;
    }

    return menuItems.map((item) => ({
        id: item.Id,
        name: item.Name,
        link: {
            url: item.Link.Url,
            target: item.Link.Target,
        },
        isActive: item.IsActive,
        isExternalLink: item.IsExternalLink,
        submenuItems: subMenuConfigMapper(item.SubMenuItems ?? []),
    }));
};

const nativeMenuConfigMapper = (nativeMenuItems: ScNativeMenuItem[]): MenuItem[] | undefined => {
    if (nativeMenuItems == null || !nativeMenuItems.length) {
        return undefined;
    }
    return nativeMenuItems.map((item) => ({
        name: item.Name,
        link: {
            url: item.Link.Url,
        },
        small: item.Small,
    }));
};

const logoConfigMapper = (logo: ScLogo | undefined): LogoProps | undefined => {
    if (!logo) {
        return undefined;
    }

    return {
        src: logo.Src,
        altText: logo.AltText,
        homePath: logo.HomePath,
    };
};

const linkMapper = (link: MalbankLink | undefined): Link | undefined => {
    if (!link || !link.Url) {
        return undefined;
    }

    return {
        url: link.Url,
        name: link.Text,
        target: link.Target,
    };
};

const linkAppHeader = (headerApp: HeaderApp | undefined): HeaderAppProps | undefined => {
    if (!headerApp) {
        return undefined;
    }
    return {
        srcRoot: headerApp.SrcRoot,
        namespace: headerApp.Namespace,
        config: headerApp.Config,
    };
};

export { menuConfigMapper, nativeMenuConfigMapper, logoConfigMapper, linkMapper, linkAppHeader };
